import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-quick-menu-item',
  templateUrl: './quick-menu-item.component.html',
  styleUrls: ['./quick-menu-item.component.scss'],
})

/**
 * Quick menu item
 */
export class QuickMenuItemComponent {
  @Input() icon?: string;
  @Output() clickAction = new EventEmitter<any>();

  /**
   * Emits click action event for underlying material button
   */
  emitClick() {
    this.clickAction.emit();
  }
}
